
export default function AboutSection() {
  return (
    <section id="sobre-nosotros" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Creamos Magia
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-purple-600">
                en Cada Página
              </span>
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Somos una familia apasionada por la educación infantil y las manualidades. Cada libro de fieltro 
              que creamos está diseñado con amor y pensado para estimular los sentidos, la creatividad y el 
              aprendizaje de los más pequeños.
            </p>

            <div className="space-y-6 mb-8">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-r from-pink-500 to-purple-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-heart-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Hecho con Amor</h3>
                  <p className="text-gray-600">Cada puntada está hecha a mano con dedicación y cariño, pensando en la sonrisa de cada niño.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-r from-pink-500 to-purple-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-leaf-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Materiales Naturales</h3>
                  <p className="text-gray-600">Utilizamos solo fieltro de lana natural y materiales eco-friendly, seguros para los niños.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-gradient-to-r from-pink-500 to-purple-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-graduation-cap-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Educación Sensorial</h3>
                  <p className="text-gray-600">Diseñamos cada libro para estimular diferentes sentidos y habilidades de desarrollo infantil.</p>
                </div>
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8 pt-8 border-t border-gray-200">
              <div className="text-center">
                <div className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-purple-600 mb-2">
                  500+
                </div>
                <div className="text-gray-600">Libros Creados</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-500 to-purple-600 mb-2">
                  300+
                </div>
                <div className="text-gray-600">Familias Felices</div>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative z-10">
              <img
                src="https://static.readdy.ai/image/65388bb12ee513dcffc13c09740f68f7/f3b15cb96bae8d29fbf67b42666dd44b.jpeg"
                alt="Artesana creando libros de fieltro"
                className="w-full h-auto rounded-3xl shadow-2xl object-cover object-top"
              />
            </div>
            
            {/* Decorative elements */}
            <div className="absolute -top-6 -left-6 w-24 h-24 bg-gradient-to-r from-pink-400 to-purple-500 rounded-full opacity-20 animate-pulse"></div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-gradient-to-r from-purple-400 to-pink-500 rounded-full opacity-20 animate-pulse delay-1000"></div>
            
            {/* Floating elements */}
            <div className="absolute top-10 -right-4 bg-white rounded-2xl p-4 shadow-lg">
              <div className="flex items-center space-x-2">
                <i className="ri-star-fill text-yellow-400 text-xl"></i>
                <div>
                  <div className="font-bold text-gray-900">4.9/5</div>
                  <div className="text-sm text-gray-600">Valoración</div>
                </div>
              </div>
            </div>
            
            <div className="absolute bottom-10 -left-4 bg-white rounded-2xl p-4 shadow-lg">
              <div className="flex items-center space-x-2">
                <i className="ri-heart-fill text-red-400 text-xl"></i>
                <div>
                  <div className="font-bold text-gray-900">100%</div>
                  <div className="text-sm text-gray-600">Amor</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
